@if (product$ | async; as product) {
  @if (product?.additionalText) {
    <div class="additional-text container">
      <h3>{{ 'productDetails.additionalTextHeader' | cxTranslate}}</h3>
      <div [innerHTML]="product?.additionalText"></div>
    </div>
  }
}
